export default function PHP_sprintf() {
  return (
    <div>
      <h1>PHP_sprintf</h1>
    </div>
  );
}
